import { render, staticRenderFns } from "./UserResInfo.vue?vue&type=template&id=3f97038a"
import script from "./UserResInfo.vue?vue&type=script&lang=js"
export * from "./UserResInfo.vue?vue&type=script&lang=js"
import style0 from "./UserResInfo.vue?vue&type=style&index=0&id=3f97038a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports